/**
 * Route for `gdpr-dsr`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { GdprDsrPage } from "../features/gdpr-dsr/GdprDsrPage";

export const gdprDsrRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/gdpr-dsr",
	component: GdprDsrPage,
});

export default gdprDsrRoute;
